export const SET_DEALER_INFO = 'setDealerInfo';
export const SET_SPEC_PIC_DATA = 'SET_SPEC_PIC_DATA';
export const SET_DEALER_SPEC_LIST = 'SET_DEALER_SPEC_LIST';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_PHONE_CALL_STATUS = 'SET_PHONE_CALL_STATUS';
